import MultiLineChart from "../components/MultiLineChart";
// import BarChart from "../components/BarChart";
import DonutChartGroup from "../components/DonutChartGroup";
import { Link } from "react-router-dom";
import VerifyCustomer from "../components/VerifyCustomer";

export default function Dashboard({ lang, dir }) {
  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Dashboard || "Dashboard"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
            </ol>
          </nav>
        </div>
        <section className="section dashboard">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-xxl-3 col-md-3">
                  <button
                    className="info-card revenue-card btn btn-primary w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#verifycustomer"
                  >
                    <div className="card-body d-flex align-items-center justify-content-center p-0">
                      <h5 className="text-center mb-0">
                        {lang.Verify || "Verify"}
                      </h5>
                    </div>
                  </button>
                </div>

                <div className="col-xxl-3 col-md-3">
                  <Link
                    to={"report"}
                    className="info-card revenue-card btn btn-primary w-100"
                  >
                    <div className="card-body d-flex align-items-center justify-content-center p-0">
                      <h5 className="text-center mb-0">
                        {lang.Reports || "Reports"}
                      </h5>
                    </div>
                  </Link>
                </div>

                <Link
                  to={"contracts/valid-contract"}
                  className="col-xxl-3 col-md-3"
                >
                  <button className="info-card revenue-card btn btn-primary w-100">
                    <div className="card-body d-flex align-items-center justify-content-center p-0">
                      <h5 className="text-center mb-0">
                        {lang.Contracts || "Contracts"}
                      </h5>
                    </div>
                  </button>
                </Link>

                <Link to={"notes"} className="col-xxl-3 col-md-3">
                  <button className="info-card revenue-card btn btn-primary w-100">
                    <div className="card-body d-flex align-items-center justify-content-center p-0">
                      <h5 className="text-center mb-0">
                        {lang["Follow Up Notes"] || "Follow Up Notes"}
                      </h5>
                    </div>
                  </button>
                </Link>

                <div>
                  <MultiLineChart lang={lang} />
                </div>
                <div>
                  <DonutChartGroup lang={lang} />
                </div>
                <div>{/* <BarChart /> */}</div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <a
        href="/"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i className="fa fa-arrow-up-short"></i>
      </a>
      <VerifyCustomer lang={lang} />
    </>
  );
}
